import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { WhatsAppChatRequest } from '../services/whatsapp/whatsappContactService';

interface WhatsAppInboxContextValue {
  openChat: (request: WhatsAppChatRequest) => void;
  pendingChat: WhatsAppChatRequest | null;
  clearPendingChat: () => void;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

const WhatsAppInboxContext = createContext<WhatsAppInboxContextValue | null>(null);

export function WhatsAppInboxProvider({ children }: { children: React.ReactNode }) {
  const [pendingChat, setPendingChat] = useState<WhatsAppChatRequest | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const openChat = useCallback((request: WhatsAppChatRequest) => {
    setPendingChat(request);
    setIsOpen(true);
  }, []);

  const clearPendingChat = useCallback(() => {
    setPendingChat(null);
  }, []);

  const value = useMemo(
    () => ({
      openChat,
      pendingChat,
      clearPendingChat,
      isOpen,
      setIsOpen,
    }),
    [openChat, pendingChat, clearPendingChat, isOpen]
  );

  return <WhatsAppInboxContext.Provider value={value}>{children}</WhatsAppInboxContext.Provider>;
}

export function useWhatsAppInbox(): WhatsAppInboxContextValue {
  const context = useContext(WhatsAppInboxContext);
  if (!context) {
    throw new Error('useWhatsAppInbox must be used within WhatsAppInboxProvider');
  }
  return context;
}
